SupportServiceActionsBaseView = require('./service_action_base')
SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache')
SupportMultipleQtyPopupView = require('../../multiple_Qty_Popup_View')

class SupportViewVoucherServiceActionView extends SupportServiceActionsBaseView

  initialize: ->
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @template = SupportServiceActionButtonTemplate
    @order = Groupon.Support.currentOrder

  render: ->
    @$el.append toHtml(@template, @toHash(), @I18nScope)
    unless @shouldShowPopup()
      @addHref @getUrlForVoucher @order.groupons[0]

  toHash: ->
    button_title = if @isSingleGroupon() then @getSingleActionTitle() else @getMultipleItemTitle()
    hash =
      service_action_id : "view_voucher"

    if @isSingleGroupon()
      hash.service_action = I18n.t("js.modules.support.view_voucher")
      @extendSingleGrouponParams(hash)
    else
       hash.service_action = I18n.t("js.modules.support.view_vouchers")
    @extendHash(hash)

  actionHandler: (event)->
    current_order = Groupon.Support.currentOrder
    if @shouldShowPopup()
      args =
        orders: @order
        serviceActionName: 'view_voucher'
        singleActionButtonCallback: @getUrlForVoucher
        groupActionButtonCallback: @getUrlForAllVouchers
        showgroupActionButton: not @isSingleGroupon()
        title: @getMultipleItemTitle()
        singleActionButtonName: @getSingleActionTitle()
        groupActionButtonName: @getGroupActionTitle()
        showAlertMessage: @shouldShowAlertMessage()
        alertMessage: I18n.t("js.modules.support.view_voucher_warning")
      multipleQtyPopup = new SupportMultipleQtyPopupView(args)
      multipleQtyPopup.render()

    return true

  getMultipleItemTitle: () ->
    I18n.t("js.modules.support.view_vouchers")

  getSingleActionTitle: () ->
    I18n.t("js.modules.support.view_voucher")

  getGroupActionTitle: () ->
    I18n.t("js.modules.support.view_all_vouchers")

  shouldShowPopup: () ->
    (not @isSingleGroupon()) or @shouldShowAlertMessage()

  shouldShowAlertMessage: () ->
    return @order && evaluate(@order.isEditable)

  getUrlForAllVouchers:(order_id)->
    url = "/users/#{ currentUser.id }/vouchers/print.pdf?order_id=#{order_id}"
    url

  getUrlForVoucher: (groupon) ->
    if window.isIntl()
      url = groupon.voucherUrl
    else if window.isNeedish()
      url = groupon.voucherUrl || "/users/#{ currentUser.id }/vouchers/#{groupon.redemptionCode}.pdf"
    else
      url = "/users/#{ currentUser.id }/vouchers/#{groupon.id}.pdf"
    url

  addHref : (url) ->
    @$el.find('#view_voucher').attr('href', url)

  renderErrorPage: ->
    flash('error', "Error when contacting server for Voucher PDF")

  events :
    "click #view_voucher"  : "actionHandler"

module.exports = SupportViewVoucherServiceActionView
